import { CheckCircle2, Clock, type LucideProps } from 'lucide-react'
import { cn } from '@/lib/utils'

/** The "going" glyph: a filled check, or a clock when only part of the set is planned. */
export function GoingCheckIcon({ partial, className, ...props }: LucideProps & { partial?: boolean }) {
  const Icon = partial ? Clock : CheckCircle2
  return <Icon className={cn('fill-going text-going-foreground', className)} {...props} />
}
